import React, { useState } from 'react';
import { css } from 'twin.macro';
import { Dialog, DialogContent } from './RefreshAction.style';
import Backdrop from '../../styled components/Backdrop';
import MessageBar from '../MessageBar/MessageBar';
import Button from '../Button/Button';

const RefreshAction = (props) => {
  const [showAction, setShowAction] = useState(true);

  const handleRefreshButtonClick = (event) => {
    window.location.reload();
    setShowAction(false);
  };

  if (showAction)
    return (
      <div
        tw="fixed inset-0"
        css={css`
          z-index: 1300;
        `}
      >
        <Backdrop />
        <Dialog>
          <DialogContent>
            <MessageBar
              variant="warning"
              title={i18n('Update Available')}
              tw="inline-block mb-8"
            >
              {i18n(
                'A new version of the App has just been released! Refresh this page to continue in the new version.'
              )}
            </MessageBar>
            <Button color="primary" variant="filled" onClick={handleRefreshButtonClick}>
              {i18n('Refresh Page')}
            </Button>
          </DialogContent>
        </Dialog>
      </div>
    );
  return null;
};

export default RefreshAction;
